export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(";").shift();
};

export const setCookie = (name, value, days) => {
    let expires = "";

    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    } else {
        expires = ";expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;";
    }

    document.cookie =
        name +
        "=" +
        (value || "") +
        expires +
        "; path=/; SameSite=None; Secure";
};

export const deleteCookie = (name) => {
    document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
